module.exports = __webpack_public_path__ + "img/24.6e2e33b3.gif";